function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';
import styled, { keyframes, css } from 'styled-components';
import '../Div/index.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Div } from '../Div/Div.js';
const Lightbox = ({
  close,
  children
}) => {
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    shouldClose = _useState2[0],
    setShouldClose = _useState2[1];
  const overlayRef = useRef(document.createElement('div'));
  useEffect(() => {
    setShouldClose(false);
  }, []);
  useEffect(() => {
    if (document.body) {
      const ref = overlayRef.current;
      document.body.appendChild(ref);
      return () => {
        document.body.removeChild(ref);
      };
    }
  }, []);
  useEffect(() => {
    if (shouldClose && close) {
      setTimeout(() => close(), 200);
    }
  }, [shouldClose, close]);

  // eslint-disable-next-line react-perf/jsx-no-new-function-as-prop, @typescript-eslint/no-explicit-any -- TODO Fix this
  const handleKeyPress = event => {
    if (event.key === 'Escape' && !shouldClose) {
      setShouldClose(true);
    }
  };
  return /*#__PURE__*/createPortal(/*#__PURE__*/jsxs(Overlay, {
    flexDirection: "column",
    zIndex: 40,
    position: "fixed",
    width: "100%",
    height: "100%",
    left: 0,
    top: 0,
    onKeyDown: handleKeyPress,
    css: {
      backgroundColor: '#000000e6'
    },
    show: !shouldClose
    // eslint-disable-next-line react-perf/jsx-no-new-function-as-prop -- TODO Fix this
    ,

    onClick: () => setShouldClose(true),
    children: [/*#__PURE__*/jsx(Div, {
      justifyContent: "flex-end",
      children: /*#__PURE__*/jsx(CloseButton, {
        onClick: () => setShouldClose(true)
      })
    }), /*#__PURE__*/jsx(Div, {
      spacing: 1,
      flex: 1,
      position: "relative",
      css: {
        margin: 24
      },
      children: children
    })]
  }), overlayRef.current);
};

// eslint-disable-next-line @cbhq/theme-no-static-value -- TODO Fix this
const CloseButton = styled.button`
  height: 32px;
  width: 32px;
  margin: 16px 16px 0;

  font-size: 24px;

  background: none;
  color: white;

  &:hover {
    color: gray;
    cursor: pointer;
  }

  &:before {
    content: '✕';
  }
`;
const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;
const fadeOut = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;
const Overlay = styled(Div).withConfig({
  shouldForwardProp: p => !['show'].includes(p)
})`
  width: 100%;

  animation: ${fadeIn} ${({
  show
}) => show ? 200 : 0}ms ease-in;

  ${({
  show
}) => !show && css`
      animation: 200ms ${fadeOut} forwards;
    `}
`;
export { Lightbox };
//# sourceMappingURL=Lightbox.js.map
